export const SCROLL_TARGET_NAME_ATTRIBUTE: string = 'data-scroll-target-name';
